import React from 'react';
import { Row, Col } from 'antd';
import styles from './style.module.less';

const DesiredPartner = ({ profile_list }) => {
  const profiles = profile_list?.Profiles;
  const profileData =
    Array.isArray(profiles) && profiles.length > 0
      ? profiles[0]
      : profiles || {};

  const min_age = profileData?.ProfileDesiredPartners?.[0]?.min_age;
  const max_age = profileData?.ProfileDesiredPartners?.[0]?.max_age;

  const min_hight = profileData?.ProfileDesiredPartners?.[0]?.min_height;
  const max_hight = profileData?.ProfileDesiredPartners?.[0]?.max_height;
  // const annual_income =
  //   profileData?.ProfileDesiredPartners?.[0]?.annual_income || 'N/A';
  // const annual_income = profileData?.ProfileDesiredPartners?.[0]?.annual_income
  //   ? Number(
  //       profileData.ProfileDesiredPartners[0].annual_income
  //     ).toLocaleString()
  //   : 'N/A';
  const annual_income = profileData?.ProfileDesiredPartners?.[0]?.annual_income
    ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency:
          profileData?.ProfileDesiredPartners?.[0]?.Currency?.currency_code &&
          profileData?.ProfileDesiredPartners?.[0]?.Currency?.currency_code !==
            'N/A'
            ? profileData?.ProfileDesiredPartners?.[0]?.Currency?.currency_code
            : 'INR' // Default to USD if currency is 'N/A' or missing
      }).format(Number(profileData.ProfileDesiredPartners[0].annual_income))
    : 'Not provided';

  const partner_description =
    profileData?.ProfileDesiredPartners?.[0]?.partner_description ||
    'Not provided';

  const familyStatus =
    profileData?.ProfileDesiredPartners?.[0]?.FamilyStatus?.status ||
    'Not provided';
  const familyType =
    profileData?.ProfileDesiredPartners?.[0]?.FamilyType?.type ||
    'Not provided';
  const FamilyValue =
    profileData?.ProfileDesiredPartners?.[0]?.FamilyValue?.values ||
    'Not provided';
  // const location = profileData?.ProfileDesiredPartners?.[0]
  //   ? `${profileData?.ProfileDesiredPartners[0]?.City?.city}, ${profileData?.ProfileDesiredPartners[0]?.Country?.country}`
  //   : 'N/A';
  const City_location =
    profileData?.ProfileDesiredCities?.map((item) => item?.City?.city).join(
      ', '
    ) || 'Not provided';

  const educationData = profileData?.ProfileDesiredPartners?.[0];
  console.log('educationData', educationData);

  const partnerEducation = educationData?.p_edu?.education;
  const p_mother_edu = educationData?.p_mother_edu?.education;
  const p_father_edu = educationData?.p_father_edu?.education;
  // const parentEducation =
  //   educationData
  //     ?.filter((item) => item?.type === 'partners_parent')
  //     ?.map((item) => item?.HigherEducation?.education)
  //     ?.join(', ') || 'N/A';

  // console.log('educations_profileData', educations);
  return (
    <>
      <Row className={styles.Dpart}>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Age Range</span>
          <span className={styles.Dp}>
            {/* {' '}
            {min_age} - {max_age}{' '} */}
            {min_age && max_age ? `${min_age} - ${max_age}` : 'Not provided'}
          </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Height</span>
          <span className={styles.Dp}>
            {/* {' '}
            {min_hight} - {max_hight}{' '} */}
            {min_hight && max_hight
              ? `${min_hight} - ${max_hight}`
              : 'Not provided'}
          </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.age} style={{ width: '40%' }}>
            Annual Income
          </span>
          <span className={styles.Dp}> {annual_income} </span>
        </Col>
      </Row>

      <Row className={styles.Dpart} style={{ paddingTop: '15px' }}>
        <Col className={styles.colStyle}>
          <span className={styles.age} style={{ width: '47%' }}>
            Education
          </span>
          <span className={styles.Dp}>
            {' '}
            {partnerEducation || 'Not provided'}{' '}
          </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.age}>Location</span>
          <span className={styles.Dp}> {City_location} </span>
        </Col>

        <Col className={styles.colStyle}>
          <span className={styles.age} style={{ width: '40%' }}>
            Family Type
          </span>
          <span className={styles.Dp}> {familyType} </span>
        </Col>
      </Row>

      <Row className={styles.Dpart} style={{ paddingTop: '15px' }}>
        <Col className={styles.colStyle}>
          <span className={styles.age} style={{ width: '35%' }}>
            Family Status
          </span>
          <span className={styles.Dp}> {familyStatus} </span>
        </Col>
        <Col className={styles.colStyle}>
          <span className={styles.age} style={{ width: '40%' }}>
            Family Values
          </span>
          <span className={styles.Dp}> {FamilyValue} </span>
        </Col>

        <Col className={styles.colStyle}>
          <span className={styles.age} style={{ width: '45%' }}>
            Mother Education
          </span>
          <span className={styles.Dp}> {p_mother_edu || 'Not provided'} </span>
        </Col>
      </Row>

      <Row className={styles.Dpart} style={{ paddingTop: '15px' }}>
        <Col className={styles.colStyle}>
          <span className={styles.age} style={{ width: '45%' }}>
            Father Education
          </span>
          <span className={styles.Dp}> {p_father_edu || 'Not provided'} </span>
        </Col>
      </Row>
      <Row className={styles.Dpart}>
        <Col className={styles.colStyle}>
          <span
            className={styles.age}
            // className={styles.colStyle}
          >
            I am looking for
          </span>
          <span className={styles.Dp}>{partner_description}</span>
        </Col>
      </Row>
    </>
  );
};

export default DesiredPartner;
